import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class StorageService {

  constructor() { }
  getStoredData() {
    var data = localStorage.getItem(location.hostname);
    return (!data) ? {} : JSON.parse(atob(decodeURIComponent(escape(data))));
  }
  setItem(Key:string, Value:any) {
    var data = null;
    data = this.getStoredData();
    data[Key] = Value;
    localStorage.setItem(location.hostname, btoa(unescape(encodeURIComponent(JSON.stringify(data)))));
  }
  getItem(Key:string) {
    var data = null;
    data = this.getStoredData();
    return data[Key];
  }
  removeItem(Key:string) {
    var data = null;
    data = this.getStoredData();
    delete data[Key];
    localStorage.setItem(location.hostname, btoa(unescape(encodeURIComponent(JSON.stringify(data)))));
  }
  clear() {
    localStorage.clear();
  }

}
